import { render, staticRenderFns } from "./Tree.vue?vue&type=template&id=a3f6b5b8&lang=pug"
import script from "./Tree.vue?vue&type=script&lang=ts"
export * from "./Tree.vue?vue&type=script&lang=ts"
import style0 from "./Tree.vue?vue&type=style&index=0&id=a3f6b5b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports